import { EmptyState, Text } from '@procurify/ui'

import { useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'

interface IGlobalSearchErrorStateProps {
  message?: Nullable<string>
}

export const GlobalSearchErrorState = ({
  message,
}: IGlobalSearchErrorStateProps) => {
  const intl = useProcurifyIntl()

  return (
    <EmptyState
      context='404'
      header={intl.formatMessage(messages.header)}
      content={<Text>{message ?? intl.formatMessage(messages.content)}</Text>}
    />
  )
}
